export default "__VITE_ASSET__Bg73VBs9__"